import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsLoaderComponent } from "./ds-loader.component";

@NgModule({
  declarations: [DsLoaderComponent],
  imports: [CommonModule],
  exports: [DsLoaderComponent],
})
export class DsLoaderModule {}
